import React from 'react';
import ReactDOM from 'react-dom/client';

// Disable console.log in production
if (!import.meta.env.DEV) {
  console.log = () => {};
  console.debug = () => {};
}

import './index.css';
import {GlobalStyles, ThemeProvider} from '@mui/material';
import {theme} from './ThemeBoe';
import UserContextProvider from './Contexts/UserContext/UserContextProvider';
import {BrowserRouter} from 'react-router-dom';
import AppBarContextProvider from './Contexts/AppBarContext/AppBarContextProvider';
import Application from './Application/Application';
import {SuperTokensWrapper} from 'supertokens-auth-react';
import {OpenAPI} from './services/openapi/core/OpenAPI';
import {init_supertokens} from './init_supertokens';
import {OverrideSuperTokensForm} from './Overwrite_SuperTokenForm';
import APIWrapperContextProvider from './services/APIWrapperContextProvider';
import './Customer.css';
import './utils/iOSPWAHandler'; // Initialize iOS PWA handler

OpenAPI.BASE =
  import.meta.env.DEV
    ? 'http://localhost:8008'
    : import.meta.env.VITE_BACKEND_URL || '';

// Enable credentials (cookies) for all API requests - required for SuperTokens session management
OpenAPI.WITH_CREDENTIALS = true;

init_supertokens();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <GlobalStyles
        styles={{
          body: {backgroundColor: 'lightyellow'},
        }}
      />
      <SuperTokensWrapper>
        <OverrideSuperTokensForm>
          <UserContextProvider>
            <AppBarContextProvider>
              <APIWrapperContextProvider>
                <BrowserRouter>
                  <Application></Application>
                </BrowserRouter>
              </APIWrapperContextProvider>
            </AppBarContextProvider>
          </UserContextProvider>
        </OverrideSuperTokensForm>
      </SuperTokensWrapper>
    </ThemeProvider>
  </React.StrictMode>
);
